import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { RouteProps } from 'react-router-dom';

import messages from '../messages';
import Image, { ImageType } from '../../../components/image/image';
import classNames from 'classnames';

interface IReady {}

const Ready: React.SFC<RouteProps & IReady> = ({}) => {
  return (
    <React.Fragment>
      <div className={classNames('c-bubble__content')}>
        <div className="c-bubble__content-text">
          <FormattedHTMLMessage {...messages.ready} />
        </div>
      </div>
      <Image
        type={ImageType.startArrow}
        imgSrc="/images/svg/arrow.svg"
        alt="Instruction Navigation"
      />
    </React.Fragment>
  );
};

export default Ready;



// WEBPACK FOOTER //
// ./src/containers/start/components/Ready.tsx